<app-modal-dialog 
[show]="showModal" 
size="lg" 
position="top"
(closed)="closedCreateNote()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Crea una Nota de Ingreso</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>
    <div class="modal-body" modal-body>
        <div class="row mb-4 border rounded-1  py-2" *ngIf="scaleNoteData != null">

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Transacción</label>
                <p class="form-control-plaintext">{{ scaleNoteData.transactionNumber }}</p>
            </div>

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">ID. Del Equipo</label>
                <p class="form-control-plaintext">{{ scaleNoteData.equipmentId }}</p>
            </div>

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Proveedor</label>
                <p class="form-control-plaintext">{{ scaleNoteData.vendorData.name }}</p>
            </div>

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Piloto</label>
                <p class="form-control-plaintext">{{ scaleNoteData.pilot }}</p>
            </div>

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Producto</label>
                <p class="form-control-plaintext">{{ scaleNoteData.productData.name }}</p>
            </div>

            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Movimiento</label>
                <p class="form-control-plaintext">{{ scaleNoteData.numberMove }}</p>
            </div>

        </div>

        <div class="row mb-4">
            <div class="row" *ngIf="scaleNoteDetails.length > 0">
                <div class="col">
                    <div class="table-responsive table-bordered">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Peso</th>
                                    <th class="td-center">Medida</th>
                                    <th class="td-center">B/T/N</th>
                                    <th class="td-center">Fecha</th>
                                    <th class="td-center">Hora</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor=" let item of scaleNoteDetails; let i = index">
                                    <td>
                                        {{item.weight}}
                                    </td>
                                    <td class="td-center">
                                        <span *ngIf="measurements">{{measurements.unit}}</span>
                                    </td>
                                    <td class="td-center">
                                        <span *ngIf="item.typeId==btnDetails[0].id">{{btnDetails[0].name}}</span>
                                        <span *ngIf="item.typeId==btnDetails[1].id">{{btnDetails[1].name}}</span>
                                        <span *ngIf="item.typeId==btnDetails[2].id">{{btnDetails[2].name}}</span>
                                    </td>
                                    <td class="text-right">
                                        {{item.date | date: 'yyyy-MM-dd'}}
                                    </td>
                                    <td class="text-right">
                                        {{item.time | date: 'HH:mm:ss'}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</app-modal-dialog>